var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/errors.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"showErrors") && runtime.memberLookup(((lineno = 0, colno = 43, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["errors"]))),"data") && runtime.contextOrFrameLookup(context, frame, "location") == runtime.memberLookup(((lineno = 0, colno = 86, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["errors"]))),"location")) {
output += "\n\n<div class=\"o-row c-form__error\">\n\n    <div class=\"c-form__field has-error\">\n\n        <div class=\"c-form-block\">\n\n            <p class=\"c-form-block__p\" data-qa-error-field>\n\n                ";
output += runtime.suppressValue(runtime.memberLookup(((lineno = 10, colno = 27, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["errors"]))),"data"), env.opts.autoescape);
output += "\n\n            </p>\n\n        </div>\n\n    </div>\n\n</div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/errors.j2"] , dependencies)